import React from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import ChecklistPage from "../checklist/ChecklistPage";

export default function EmployeeChecklistPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <EmployeeNavbar />
      <ChecklistPage />
    </div>
  );
}
